export const EVENT_SETTINGS_UPDATE = 'settings.update'
